/* ============================================================================
   NOIZZYBOX RETRO XL — behaviour. Vanilla JS, no dependencies.
   Everything degrades to a readable static page if this file never runs.
   Real Add to Cart / Buy it now are native Shopify (product-form.js + the
   theme's GoKwik buy-now button) — this file is presentational + quantity
   sync only. Price/compare-at/availability/inventory come from
   window.RXL_PRODUCT, rendered from real Liquid product data in the section
   file (see the SHOPIFY: comment there) — never hardcoded here.
   ========================================================================== */
(function () {
  'use strict';
  /* SHOPIFY: the Retro XL page used to be one giant Shopify section, wrapped
     in a single <div class="rxl" id="rxlRoot">. It has since been split into
     several smaller sections (so the theme editor's 50-block-per-section
     limit is never hit again) — each with its own <div class="rxl"> wrapper,
     rendered back-to-back on the same page. Every interactive widget below
     (hero slider, dial, room/source tabs, quantity steppers, etc.) still
     appears exactly ONCE on the whole page, just inside whichever of those
     wrapper divs now holds that piece of content — so instead of scoping
     every query to one cached root element, $/$$ simply search the whole
     document by default (or a narrower element when one is passed in — see
     initSection below). The only requirement is that at least one .rxl
     wrapper exists on the page (i.e. this really is a Retro XL page) before
     running at all. */
  if (!document.querySelector('.rxl')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  /* Whichever dial is currently on the page gets to redraw itself on
     resize — reassigned (not added-to) on every initSection call, so
     repeated section reloads never pile up extra resize listeners. */
  var redrawCurrentDial = null;

  var PRODUCT = window.RXL_PRODUCT || {
    currency: '₹', price: 0, compareAt: 0, available: false, inventory: null,
    lowStockAt: 10
  };

  function money(n) {
    return PRODUCT.currency + Math.round(n).toLocaleString('en-IN');
  }

  /* Analytics hook, shaped for GA4 ecommerce events. Forward to your
     analytics of choice — this only pushes to dataLayer if one exists. */
  function trackEvent(event, data) {
    /* This store's real GA4 property is wired via direct gtag() calls
       (snippets/gokwik.liquid), not a GTM container — a plain dataLayer
       push alone has nothing listening to translate it into a real GA4
       hit. Call gtag() directly (this site's actual pattern) and still
       push to dataLayer too, in case anything else is listening. */
    if (typeof window.gtag === 'function') window.gtag('event', event, data || {});
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  /* Always looks at the WHOLE page, never just one section — several visual
     quantity controls (hero, final CTA, sticky bar) live in different
     sections but must stay numerically in sync with each other regardless
     of which one changed. */
  function qtyInputs() { return $$('.qty input'); }

  /* ==========================================================================
     initSection(root) wires up every interactive/animated piece of content
     found within `root`. It's called once for the whole document on first
     load, AND again — scoped to just the affected section — every time
     Shopify's Customize editor live-swaps a section's HTML after an edit
     (the "shopify:section:load" event, listened for below).

     Without this second call, editing anything in Customize replaces that
     section's DOM with brand-new elements that have never been wired up:
     [data-reveal] elements start at opacity:0 and only ever become visible
     once JS marks them "is-in" (see the reveal block below), and every
     click-driven widget (room/source tabs, the dial, quantity buttons, the
     hero slider, etc.) simply has no listener attached yet — which is
     exactly the "the page goes blank after I edit something, and I have to
     exit and re-enter to see it" report. Re-running this function scoped to
     only the section that was just reloaded fixes that, without touching or
     double-binding anything in the sections that didn't change.
     ========================================================================== */
  function initSection(root) {
    /* ---- commerce text: price / compare / save / delivery / stock ----
       Idempotent — safe to re-run on the same elements more than once. */
    var save = PRODUCT.compareAt - PRODUCT.price;
    var pct  = PRODUCT.compareAt ? Math.round(save / PRODUCT.compareAt * 100) : 0;

    $$('[data-price]', root).forEach(function (el) { el.textContent = money(PRODUCT.price); });
    $$('[data-compare]', root).forEach(function (el) {
      if (PRODUCT.compareAt > PRODUCT.price) el.textContent = money(PRODUCT.compareAt);
      else el.style.display = 'none';
    });
    $$('[data-save]', root).forEach(function (el) {
      if (save > 0) el.textContent = 'Save ' + money(save) + ' (' + pct + '%)';
      else el.style.display = 'none';
    });

    /* Low stock: shown ONLY when a real inventory number says so. No timers,
       no invented "3 left" — false urgency is a dark pattern. */
    var n = PRODUCT.inventory;
    if (typeof n === 'number' && n > 0 && n <= PRODUCT.lowStockAt) {
      $$('[data-stock]', root).forEach(function (el) { el.classList.add('is-on'); });
      $$('[data-stocktext]', root).forEach(function (el) { el.textContent = 'Only ' + n + ' left in stock'; });
    }

    /* ---- quantity steppers ----
       Buttons/inputs *within root* get (re)bound; qtyInputs() itself always
       looks at the whole page, so a click anywhere still syncs every visual
       quantity control regardless of which section it lives in. */
    $$('[data-qty]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('input');
        var next = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10)));
        qtyInputs().forEach(function (i) { i.value = next; });
      });
    });
    $$('.qty input', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var v = Math.min(10, Math.max(1, parseInt(input.value, 10) || 1));
        qtyInputs().forEach(function (i) { i.value = v; });
      });
    });

    /* ---- reveal ---- */
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      $$('[data-reveal]', root).forEach(function (el) { io.observe(el); });
    } else {
      $$('[data-reveal]', root).forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---- hero angle slider ----
       3 real angles in fixed left/centre/right slots. Clicking a side image
       swaps its slot with the centre one, so it visually glides to the
       middle (animated via CSS transition on the slot-driven `left`/
       transform, not a class-toggle-in-place) rather than just becoming
       brighter where it sits. No-ops entirely when root doesn't contain the
       hero (e.g. when a different section reloaded). */
    var slides = $$('.hero__slide', root), dots = $$('.hero__dot', root);
    if (slides.length) {
      var setActiveSlide = function (angle) {
        var clicked = slides.filter(function (s) { return s.dataset.angle === angle; })[0];
        if (!clicked || clicked.dataset.slot === 'center') return;
        var centerSlide = slides.filter(function (s) { return s.dataset.slot === 'center'; })[0];
        var clickedSlot = clicked.dataset.slot;
        if (centerSlide) centerSlide.dataset.slot = clickedSlot;
        clicked.dataset.slot = 'center';
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slot === 'center'); });
        dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.angle === angle); });
      };
      slides.forEach(function (s) {
        s.addEventListener('click', function () { setActiveSlide(s.dataset.angle); });
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { setActiveSlide(d.dataset.angle); });
      });

      /* ---- prev/next arrows ----
         Mobile hides the left/right slide buttons entirely (only the centre
         one renders), so tapping a side photo isn't possible there and
         there's no swipe gesture — these arrows are the only way to change
         angle on a phone. Order follows DOM order, not the current slot,
         so it stays correct no matter which angle is currently centred. */
      var angleOrder = slides.map(function (s) { return s.dataset.angle; });
      var step = function (dir) {
        var current = slides.filter(function (s) { return s.dataset.slot === 'center'; })[0];
        if (!current) return;
        var i = angleOrder.indexOf(current.dataset.angle);
        var next = angleOrder[(i + dir + angleOrder.length) % angleOrder.length];
        setActiveSlide(next);
      };
      var prevBtn = $('[data-hero-nav="prev"]', root), nextBtn = $('[data-hero-nav="next"]', root);
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    }

    /* ---- hero cursor parallax ----
       Applied to the <img> nested inside the centre slide, not the slide
       button itself — the button's own transform already drives slot
       positioning (translate + scale), so nudging that directly would fight
       the slot animation. */
    var heroEl = $('.hero', root);
    if (!reduce && window.matchMedia('(pointer:fine)').matches && heroEl) {
      var raf = null, tx = 0, ty = 0;
      heroEl.addEventListener('pointermove', function (e) {
        var activeImg = $('.hero__slide[data-slot="center"] img', root);
        if (!activeImg) return;
        var r = heroEl.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 14;
        ty = ((e.clientY - r.top) / r.height - 0.5) * 10;
        if (!raf) raf = requestAnimationFrame(function () {
          activeImg.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0)';
          raf = null;
        });
      });
      heroEl.addEventListener('pointerleave', function () {
        var activeImg = $('.hero__slide[data-slot="center"] img', root);
        if (activeImg) activeImg.style.transform = '';
      });
    }

    /* ---- the frequency dial ----
       Presentational only — no product data, no real audio (by request).
       Drag/keys still fully work; it just illustrates the tuning
       experience. Re-running this (because the section containing the dial
       itself was live-edited) resets the currently-tuned station back to
       the FM default — a minor, acceptable trade-off, since the section
       that owns the dial has just had its markup replaced wholesale
       anyway. */
    var BANDS = {
      FM: { min: 87,  max: 108,  unit: 'MHz', step: 0.1, dp: 1, majorEvery: 1, labelEvery: 3 },
      AM: { min: 530, max: 1600, unit: 'kHz', step: 10,  dp: 0, majorEvery: 100, labelEvery: 200 },
      SW: { min: 5.9, max: 18,   unit: 'MHz', step: 0.1, dp: 1, majorEvery: 1, labelEvery: 2 }
    };
    var STATIONS = {
      FM: [[88.3,'Late night jazz'],[91.1,'Carnatic hour'],[93.5,'Golden oldies'],[98.3,'City talk'],[101.6,'Vinyl requests'],[104.8,'Ghazal evenings'],[107.1,'Test tone']],
      AM: [[594,'National service'],[720,'Cricket commentary'],[1017,'Regional news'],[1350,'Old film songs']],
      SW: [[6.1,'World service'],[9.6,'Shortwave relay'],[13.7,'Distant signal'],[17.8,'Skip propagation']]
    };
    var track = $('#rxlDialTrack', root), inner = $('#rxlDialInner', root), needle = $('#rxlDialNeedle', root), hairs = $('#rxlDialHairs', root);
    var numEl = $('#rxlDialNum', root), unitEl = $('#rxlDialUnit', root), stationEl = $('#rxlDialStation', root);
    if (track || hairs) {
      var band = 'FM', val = 98.3;

      var drawHairs = function () {
        if (!hairs) return;
        var b = BANDS[band];
        hairs.innerHTML = '';
        var sub = b.majorEvery / 5;
        var labelEvery = window.innerWidth < 620 ? b.labelEvery * 2 : b.labelEvery;
        var steps = Math.round((b.max - b.min) / sub);
        for (var i = 0; i <= steps; i++) {
          var v = b.min + i * sub;
          var pos = (v - b.min) / (b.max - b.min);
          var onMajor = i % 5 === 0;
          var onLabel = Math.abs((v - b.min) % labelEvery) < sub / 2;
          var h = document.createElement('span');
          h.className = 'dial__hair' + (onLabel ? ' maj' : '');
          h.style.left = (pos * 100) + '%';
          h.style.height = onLabel ? '24px' : (onMajor ? '15px' : '8px');
          if (!onMajor) h.style.opacity = '.45';
          hairs.appendChild(h);
          if (onLabel) {
            var l = document.createElement('span');
            l.className = 'dial__lbl';
            l.style.left = (pos * 100) + '%';
            l.textContent = v.toFixed(b.dp);
            hairs.appendChild(l);
          }
        }
      };

      var renderDial = function () {
        var b = BANDS[band];
        var pos = (val - b.min) / (b.max - b.min);
        if (needle) needle.style.left = (pos * 100) + '%';
        if (numEl) numEl.textContent = val.toFixed(b.dp);
        if (unitEl) unitEl.textContent = b.unit;
        if (track) {
          track.setAttribute('aria-valuemin', b.min);
          track.setAttribute('aria-valuemax', b.max);
          track.setAttribute('aria-valuenow', val.toFixed(b.dp));
          track.setAttribute('aria-valuetext', val.toFixed(b.dp) + ' ' + b.unit + ', ' + band);
        }
        var tol = (b.max - b.min) * 0.014, best = null, bd = Infinity;
        (STATIONS[band] || []).forEach(function (s) {
          var d = Math.abs(s[0] - val);
          if (d < bd) { bd = d; best = s; }
        });
        if (stationEl) stationEl.textContent = (best && bd <= tol) ? best[1] : 'Searching…';
        if (needle) needle.style.opacity = (best && bd <= tol) ? '1' : '.55';
      };

      var setFromClientX = function (clientX) {
        var b = BANDS[band], r = inner.getBoundingClientRect();
        var pos = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
        var raw = b.min + pos * (b.max - b.min);
        val = Math.round(raw / b.step) * b.step;
        val = Math.min(b.max, Math.max(b.min, +val.toFixed(3)));
        renderDial();
      };

      if (track) {
        var dragging = false;
        track.addEventListener('pointerdown', function (e) {
          dragging = true; track.setPointerCapture(e.pointerId); setFromClientX(e.clientX);
        });
        track.addEventListener('pointermove', function (e) { if (dragging) setFromClientX(e.clientX); });
        ['pointerup', 'pointercancel'].forEach(function (t) {
          track.addEventListener(t, function () { dragging = false; });
        });
        track.addEventListener('keydown', function (e) {
          var b = BANDS[band], k = e.key, s = b.step;
          if (k === 'ArrowRight' || k === 'ArrowUp') val += s;
          else if (k === 'ArrowLeft' || k === 'ArrowDown') val -= s;
          else if (k === 'PageUp') val += s * 10;
          else if (k === 'PageDown') val -= s * 10;
          else if (k === 'Home') val = b.min;
          else if (k === 'End') val = b.max;
          else return;
          e.preventDefault();
          val = Math.min(b.max, Math.max(b.min, +val.toFixed(3)));
          renderDial();
        });
      }
      $$('[data-dialband]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          band = btn.dataset.dialband;
          $$('[data-dialband]', root).forEach(function (o) { o.setAttribute('aria-pressed', String(o === btn)); });
          var b = BANDS[band], list = STATIONS[band] || [];
          val = list.length ? list[Math.floor(list.length / 2)][0]
                            : +(b.min + (b.max - b.min) * 0.54).toFixed(b.dp);
          drawHairs(); renderDial();
        });
      });
      drawHairs(); renderDial();
      redrawCurrentDial = drawHairs;
    }

    /* ---- sound character comparison ---- */
    var wave = $('#rxlWave', root), tuneNote = $('#rxlTuneNote', root);
    if (wave || tuneNote || $('[data-tune]', root)) {
      var TUNE = {
        hybrid: { amp: 1,   note: 'Balanced across the range — vocals stay forward and the low end supports the music instead of covering it.' },
        bass:   { amp: 2.4, note: 'What a bass-first speaker does to the same track: the low end swells and everything else moves behind it.' }
      };
      var setTune = function (mode) {
        var t = TUNE[mode];
        if (wave) wave.style.setProperty('--amp', t.amp);
        if (tuneNote) tuneNote.textContent = t.note;
        $$('[data-tune]', root).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.tune === mode));
        });
      };
      $$('[data-tune]', root).forEach(function (b) {
        b.addEventListener('click', function () { setTune(b.dataset.tune); });
      });
      setTune('hybrid');
    }

    /* ---- THEN x NOW ---- */
    var tn = $('#rxlTn', root), tnThen = $('#rxlTnThen', root), tnNow = $('#rxlTnNow', root);
    if (tn) {
      var setTn = function (mode) {
        tn.classList.toggle('is-then', mode === 'then');
        /* Clicking "Now" highlights both columns rather than dimming
           "Then" — clicking "Then" still dims "Now" as before, per
           explicit request (only the Now click behavior changed). */
        tnThen.classList.add('is-live');
        tnThen.classList.remove('is-dim');
        tnNow.classList.toggle('is-live',  mode !== 'then');
        tnNow.classList.toggle('is-dim',   mode === 'then');
        $$('[data-tn]', root).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.tn === mode));
        });
      };
      $$('[data-tn]', root).forEach(function (b) {
        b.addEventListener('click', function () { setTn(b.dataset.tn); });
      });
    }

    /* ---- room placement tabs ----
       Room content (title/copy/placeholder/photo) is rendered by Liquid from
       this section's "room" blocks — see the section file — and read back
       here from data-* attributes on each tab button, so editing a block in
       Customize changes what clicking its tab shows. No content is hardcoded
       in this file. */
    var roomImg = $('#rxlRoomImg', root), roomTitle = $('#rxlRoomTitle', root), roomCopy = $('#rxlRoomCopy', root);
    if (roomImg) {
      $$('[data-room]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          roomTitle.textContent = b.dataset.title;
          roomCopy.textContent  = b.dataset.copy;
          if (b.dataset.image) {
            var alt = (b.dataset.title || '').replace(/"/g, '&quot;');
            roomImg.innerHTML = '<img src="' + b.dataset.image + '" alt="' + alt + '" style="width:100%;height:100%;object-fit:cover;display:block">';
          } else {
            roomImg.textContent = b.dataset.placeholder || '';
          }
          $$('[data-room]', root).forEach(function (o) {
            o.setAttribute('aria-selected', String(o === b));
          });
          trackEvent('view_room', { room: b.dataset.title });
        });
      });
    }

    /* ---- source switcher over the faceplate ----
       AUX intentionally excluded — Retro XL has no AUX input. Source content
       (label/description/marker position) comes from this section's "source"
       blocks, rendered by Liquid onto data-* attributes on each tab button —
       same pattern as the room tabs above, nothing hardcoded here. */
    var srcRing = $('#rxlSrcRing', root), srcTitle = $('#rxlSrcTitle', root), srcCopy = $('#rxlSrcCopy', root);
    if (srcRing) {
      $$('[data-src]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          srcRing.style.opacity = '1';
          srcRing.style.left = b.dataset.x + '%';
          srcRing.style.top  = b.dataset.y + '%';
          srcTitle.textContent = b.dataset.title;
          srcCopy.textContent  = b.dataset.copy;
          $$('[data-src]', root).forEach(function (o) {
            o.setAttribute('aria-selected', String(o === b));
          });
          trackEvent('view_source', { source: b.dataset.title });
        });
      });
    }

    /* ---- turn it on ---- */
    var barsWrap = $('.bars', root);
    if (barsWrap && !barsWrap.childElementCount) {
      for (var i = 0; i < 28; i++) {
        var bar = document.createElement('i');
        bar.style.animationDelay = (i * 0.055).toFixed(2) + 's';
        bar.style.animationDuration = (0.9 + (i % 5) * 0.16).toFixed(2) + 's';
        barsWrap.appendChild(bar);
      }
    }
    var powerBtn = $('#rxlPowerBtn', root), powerSec = $('#rxlPower', root);
    if (powerBtn && powerSec) {
      powerBtn.addEventListener('click', function () {
        var on = !powerSec.classList.contains('is-on');
        powerSec.classList.toggle('is-on', on);
        powerBtn.setAttribute('aria-pressed', String(on));
        powerBtn.textContent = on ? 'Playing' : 'Turn it on';
      });
    }

    /* ---- lightbox ---- */
    var lb = $('#rxlLb', root), lbImg = $('#rxlLbImg', root), lbClose = $('#rxlLbClose', root);
    var openLb = function (src, alt) {
      if (!lb || !lb.showModal) return;
      lbImg.src = src; lbImg.alt = alt || '';
      lb.showModal();
    };
    $$('[data-lb]', root).forEach(function (t) {
      var img = $('img', t);
      t.addEventListener('click', function () { openLb(t.dataset.lb, img && img.alt); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(t.dataset.lb, img && img.alt); }
      });
    });
    if (lbClose) lbClose.addEventListener('click', function () { lb.close(); });
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });

    /* Add to cart / buy it now are real (product-form.js + GoKwik) — this
       file only tracks the events; it does not intercept or fake the
       submit. */
    $$('[type="submit"][name="add"]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = qtyInputs()[0] ? (parseInt(qtyInputs()[0].value, 10) || 1) : 1;
        trackEvent('add_to_cart', { quantity: q, value: PRODUCT.price * q });
      });
    });
    $$('#gokwik-buy-now', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = qtyInputs()[0] ? (parseInt(qtyInputs()[0].value, 10) || 1) : 1;
        trackEvent('begin_checkout', { quantity: q, value: PRODUCT.price * q });
      });
    });
  }

  initSection(document);
  trackEvent('view_item', { item_name: 'NOIZZYBOX Retro XL', value: PRODUCT.price });

  /* Shopify fires this on `document` (bubbling) whenever the Customize
     editor live-replaces one section's HTML after an edit — `event.target`
     is that section's own wrapper element. Re-running initSection scoped to
     just that element wires up the fresh content without touching (or
     double-binding) anything in the sections that didn't change. */
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target);
    buildTicks(); onScroll();
  });

  /* ------------------------------------------- header and nav band
     Page-level chrome, not tied to any one section's content — every element
     here is looked up fresh (by id) on every call rather than cached, so it
     stays correct after a section reload without needing to re-bind
     anything; only listened for once. */
  var hdr = $('#rxlHdr');
  var heroWrap = $('#top');
  var marker = $('#rxlBandMarker'), ticksWrap = $('#rxlBandTicks'), now = $('#rxlBandNow');
  /* Order here must match physical page order (see the "current section"
     detection below, which walks this array in order and keeps the LAST
     match — so a stale order silently reports the wrong "currently
     viewing" section once pages get reordered). Specifications now sits
     right after the hero banner (alongside Gallery), ahead of Overview and
     Sound — see templates/product.retro-xl.json's "order" array for the
     real layout. */
  var SECTIONS = [
    { id: 'rxl-specifications', label: 'Specs' },
    { id: 'rxl-overview',       label: 'Overview' },
    { id: 'rxl-sound',          label: 'Sound' },
    { id: 'rxl-radio',          label: 'Radio' },
    { id: 'rxl-design',         label: 'Design' },
    { id: 'rxl-reviews',        label: 'Reviews' },
    { id: 'rxl-faq',            label: 'FAQ' }
  ];
  var LOW = 87, HIGH = 108;

  /* Was root.scrollHeight back when one .rxl div wrapped the whole page;
     now that the page is several sibling .rxl wrappers, the full document's
     height is the equivalent measure. */
  function docSpan() { return Math.max(1, document.documentElement.scrollHeight - window.innerHeight); }
  function fracOf(el) { return Math.min(1, Math.max(0, (el.offsetTop - 90) / docSpan())); }
  function mhzAt(f) { return (LOW + f * (HIGH - LOW)).toFixed(1); }

  function buildTicks() {
    if (!ticksWrap) return;
    ticksWrap.innerHTML = '';
    SECTIONS.forEach(function (s) {
      var el = document.getElementById(s.id);
      if (!el) return;
      var f = fracOf(el);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'band__tick';
      b.style.left = (f * 100) + '%';
      b.textContent = mhzAt(f);
      b.dataset.id = s.id;
      b.setAttribute('aria-label', 'Go to ' + s.label);
      b.addEventListener('click', function () {
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      ticksWrap.appendChild(b);
    });
  }

  var navLinks = $$('.nav a');
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (hdr) {
      hdr.classList.toggle('is-stuck', y > 40);
      /* See the .hdr.is-fixed comment in retro-xl.css — switch to fixed the
         instant the hero section's own wrapper (this header's sticky
         containing block) is about to scroll past, so the header keeps
         following for the rest of the page instead of disappearing there. */
      if (heroWrap) {
        hdr.classList.toggle('is-fixed', heroWrap.getBoundingClientRect().bottom <= hdr.offsetHeight);
      }
    }

    var f = Math.min(1, Math.max(0, y / docSpan()));
    if (marker) marker.style.left = (f * 100) + '%';

    var current = SECTIONS[0], mid = y + window.innerHeight * 0.4;
    SECTIONS.forEach(function (s) {
      var el = document.getElementById(s.id);
      if (el && el.offsetTop <= mid) current = s;
    });
    if (now) now.textContent = mhzAt(f) + ' MHz · ' + current.label;
    $$('.band__tick').forEach(function (t) { t.classList.toggle('is-on', t.dataset.id === current.id); });
    navLinks.forEach(function (a) {
      a.setAttribute('aria-current', a.getAttribute('href') === '#' + current.id ? 'true' : 'false');
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', function () {
    buildTicks(); onScroll();
    if (redrawCurrentDial) redrawCurrentDial();
  });
  window.addEventListener('load', function () { buildTicks(); onScroll(); });
  buildTicks(); onScroll();

  /* ------------------------------------------- in-page anchor smooth scroll
     Prototype relied on a page-wide html{scroll-behavior:smooth} for this;
     scoping that globally would affect the whole site, so it's a scoped
     click handler instead. Delegated on `document`, so it automatically
     covers anchors inside any section reloaded later too — no re-binding
     needed. */
  if (!reduce) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !a.closest('.rxl')) return;
      var id = a.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* Funnel instrumentation: how far down the page people actually get. */
  if ('IntersectionObserver' in window) {
    var seen = {};
    var fo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = e.target.id;
        if (seen[id]) return;
        seen[id] = 1;
        trackEvent('view_section', { section: id });
      });
    }, { threshold: 0.3 });
    ['rxl-overview','rxl-sound','rxl-radio','rxl-design','rxl-reviews','rxl-whats-included','rxl-specifications','rxl-faq']
      .forEach(function (id) { var el = document.getElementById(id); if (el) fo.observe(el); });
  }
})();
